import { useMemo, useContext } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/modern/components/ui/avatar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { User } from "@/bryntum-lib/models/User";
import BryntumContext from "@/react/context/bryntumContext";

interface ChecklistAssignedUsersProps {
  assignedBoardUsers?: number[];
  maxDisplay?: number;
  className?: string;
}

export const ChecklistAssignedUsers = ({ assignedBoardUsers, maxDisplay = 3, className }: ChecklistAssignedUsersProps) => {
  const { project } = useContext(BryntumContext);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const projectTyped = project as any;

  const assignedUsersRaw = useMemo(() => {
    if (!assignedBoardUsers || assignedBoardUsers.length === 0) return [];
    return assignedBoardUsers.map((userId) => projectTyped.boardUsersStore.getById(userId)).filter(Boolean);
  }, [assignedBoardUsers, projectTyped]);

  const assignedUsers = JSON.parse(JSON.stringify(assignedUsersRaw));

  if (assignedUsers.length === 0) return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        <div className={className}>
          <div className="flex items-center -space-x-2">
            {assignedUsers.slice(0, maxDisplay).map((user: User) => (
              <Avatar key={user.id} className="size-6 border-2 border-background">
                <AvatarImage src={user.profile_image_url} />
                <AvatarFallback className="text-xs bg-primary/10 text-primary">{user.name?.slice(0, 2).toUpperCase() || "??"}</AvatarFallback>
              </Avatar>
            ))}
            {assignedUsers.length > maxDisplay && (
              <Avatar className="size-6 border-2 border-background">
                <AvatarFallback className="text-xs bg-muted text-muted-foreground">+{assignedUsers.length - maxDisplay}</AvatarFallback>
              </Avatar>
            )}
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent>{assignedUsers.map((user: User) => user.name).join(", ")}</TooltipContent>
    </Tooltip>
  );
};
